import React from 'react'
import { LanguageContext } from '../contexts'
import classNames from 'classnames'
import { Icons } from '../constants'

// TODO: generalize into a toggle component

export type EventViewType = 'List' | 'Calendar'

// TODO: look into perhaps using this kind of structure instead of type dictionaries in other instances
const EventViewIcons: {[k in EventViewType]: string} = {
	List: Icons.hamburger, 
	Calendar: Icons.calendar
}

export interface EventViewToggleProps {
	selectedView: EventViewType
	onSelectView(viewType: EventViewType): void
	// leaving this here for now so that we have option to easily demo placement elsewhere without label
	label?: string
}

export function EventViewToggle(props: EventViewToggleProps) {
	const label = props.label ? <label className='label'>View</label> : null
	return (
		<>
			{label}
			<div className='field has-addons mr-2'>
				<EventViewButton {...props} buttonView='Calendar' />
				<EventViewButton {...props} buttonView='List' />
			</div>
		</>
	)
}

export default EventViewToggle

export interface EventViewButtonProps extends EventViewToggleProps {
	buttonView: EventViewType
}

function EventViewButton(props: EventViewButtonProps) {
	const { localizedText } = React.useContext(LanguageContext)

	const buttonClass = classNames('button', { 'is-active': props.buttonView === props.selectedView })

	return (
		<p className='control'>
			<button className={buttonClass} onClick={() => props.onSelectView(props.buttonView)} title={localizedText[props.buttonView]}>
				<span>{EventViewIcons[props.buttonView]}</span>
			</button>
		</p>
	)
}